/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AutomationdataSettings} from './AutomationdataSettings';
import {AutomationdataSource} from './AutomationdataSource';

/**
 * The AutomationDataBody model module.
 * @module model/AutomationDataBody
 * @version 1.0.0
 */
export class AutomationDataBody {
  /**
   * Constructs a new <code>AutomationDataBody</code>.
   * @alias module:model/AutomationDataBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AutomationDataBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AutomationDataBody} obj Optional instance to populate.
   * @return {module:model/AutomationDataBody} The populated <code>AutomationDataBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AutomationDataBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('tags'))
        obj.tags = ApiClient.convertToType(data['tags'], ['String']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], 'String');
      if (data.hasOwnProperty('source'))
        obj.source = AutomationdataSource.constructFromObject(data['source']);
      if (data.hasOwnProperty('destinations'))
        obj.destinations = ApiClient.convertToType(data['destinations'], [AutomationdataSource]);
      if (data.hasOwnProperty('settings'))
        obj.settings = AutomationdataSettings.constructFromObject(data['settings']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
AutomationDataBody.prototype.title = undefined;

/**
 * @member {String} description
 */
AutomationDataBody.prototype.description = undefined;

/**
 * @member {Array.<String>} tags
 */
AutomationDataBody.prototype.tags = undefined;

/**
 * @member {Boolean} enabled
 */
AutomationDataBody.prototype.enabled = undefined;

/**
 * @member {String} query
 */
AutomationDataBody.prototype.query = undefined;

/**
 * @member {module:model/AutomationdataSource} source
 */
AutomationDataBody.prototype.source = undefined;

/**
 * @member {Array.<module:model/AutomationdataSource>} destinations
 */
AutomationDataBody.prototype.destinations = undefined;

/**
 * @member {module:model/AutomationdataSettings} settings
 */
AutomationDataBody.prototype.settings = undefined;

